import axios, { type AxiosInstance } from 'axios';
import qs from 'qs';

const genericAxiosClient = axios.create({
  paramsSerializer: {
    serialize: (params: any) =>
      qs.stringify(params, { arrayFormat: 'brackets' }),
  },
  // TODO Ragionare sulla possibilità di aggiungere un retry automatico
  // anche per i servizi esterni
});

export interface IEngineAsyncClientOptions {
  isExternal: boolean;
  apiClient: AxiosInstance;
}

/**
 * Ritorna il client per le chiamate asincrone al servizio richiesto.
 * Se il servizio non è relativo al backend trusted, viene utilizzato un client
 * Axios generico.
 *
 * @param apiClient Il client Axios fornito dal context (@framework/api-client), collegato con le API
 */
export function getEngineAsyncClient({
  isExternal,
  apiClient,
}: IEngineAsyncClientOptions): AxiosInstance {
  if (isExternal) {
    return genericAxiosClient;
  }

  return apiClient;
}
